import { IconButton } from '@mui/material'
import CancelIcon from '../../../assets/icons/Cancel.svg?react'
import QuoteIcon from '../../../assets/icons/Quote.svg?react'
import {
    useTextSelectionMenuActions,
    useTextSelectionMenuStore,
} from '../../../store/storeTextSelectionMenu'
import { QuoteBody, QuoteText } from './Quote.styles'

export const Quote = () => {
    const quote = useTextSelectionMenuStore((state) => state.quote)
    const { quoteClear } = useTextSelectionMenuActions()

    if (!quote) return null

    return (
        <QuoteBody>
            <QuoteIcon />
            <QuoteText variant="caption3">{quote.replaceAll(`\n`, ' ')}</QuoteText>
            <IconButton onClick={quoteClear} sx={{ ml: 'auto' }}>
                <CancelIcon />
            </IconButton>
        </QuoteBody>
    )
}
